/* eslint-disable no-console */
<template>
<div>
    <div class="card z-depth-5 p-3">
        <h4 class="text-center font-weight-bold py-3">All Videos</h4>
        <div class="table-responsive">
            <table class="table table-bordered">
                <thead class="thead-dark">
                    <tr>
                        <th scope="col">Thumb</th>
                        <th scope="col">Title</th>
                        <th scope="col">Take Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="video in videos" :key="video._id">
                        <th><img :src="video.thumb" alt="thumb" class="img-thumbnail"></th>
                        <th>{{video.title}}</th>
                        <td>

                            <router-link :to="{name: 'Quizs', params: {videoId: video._id}}">
                                <button class="btn btn-success btn-sm">Quiz</button>
                            </router-link>

                                <button class="btn btn-primary btn-sm" @click.prevent="clickedEditButton(video)">Edit</button>

                            <button class="btn btn-danger btn-sm" @click.prevent="deleteItem(video._id)">Delete</button>


                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <mdb-container>
        <mdb-modal :show="showeditmodal" removeBackdrop centered>
            <mdb-modal-body>
                <form class="border border-light p-5" >
                    <div class="row">
                        <div class="form-group col-md-12">
                            <label>Title</label>
                            <input type="text" ref="title" v-model="selectedVideo.title" id="" class="form-control mb-4" placeholder="title">
                        </div>
                        <div class="form-group col-md-12">
                            <label>Description</label>
                            <textarea ref="description" v-model="selectedVideo.description" id="" class="form-control mb-4" rows="6" placeholder="Description">
                            </textarea>
                        </div>
                        <div class="form-group col-md-12">
                            <label>Vimeo Video</label>
                            <input type="text" ref="video" v-model="selectedVideo.video" id="" class="form-control mb-4" placeholder="video id">
                        </div>
                        <div class="form-group col-md-12">
                            <label>Thumb</label>
                            <input type="file" ref="thumb" id="" class="form-control mb-4" accept="image/jpeg, image/png">
                        </div>
                    </div>

                    <!-- Sign in button -->
                    <button class="btn btn-info btn-block my-4" @click.prevent="editItem()">Edit Video</button>

                </form>
                <div class="modal-footer">
                    <button
                          type="button"
                          class="btn btn-danger btn-sm"
                          data-dismiss="modal"
                          @click="showeditmodal = false"
                        >
                          Close
                    </button>
                </div>
            </mdb-modal-body>
            </mdb-modal>
        </mdb-container>
</div>


</template>
<style scoped>
    .avatar-body {
        position: relative
    }
    .avatar-close {
        position: absolute;
        right: 20px;
        top: 10px;
        color: red;
        background-color: white;
    }
    .img-thumbnail {
        height: 100px
    }
</style>
<script>
import axios from "axios"

import { mdbContainer, mdbModal, mdbModalBody } from "mdbvue";

export default {
    name: 'Quizs',
    components: {
        mdbContainer,
        mdbModal,
        mdbModalBody,
    },
    data() {
        return {
            videos: [],
            selectedVideo: {},
            baseUrl: "/artvideos",
            showeditmodal: false,
            fastAdminToken : localStorage.getItem("fastAdminToken")
        }
    },
    mounted() {
        this.initData();
    },
    methods: {
        initData() {
            this.selectedVideo = {};

            this.$toast.open({
                message: "Processing : Loading Levels Please Wait...",
                type: 'info'
            })

            const config = {
                headers: {
                    Authorization: "Bearer " + this.fastAdminToken,
                    'Content-Type': 'application/json'
                }
            }

            axios.get(this.$apiURI + this.baseUrl, config)
                .then((response) => {
                    if (response.data.error) {
                        this.$toast.open({
                            message: "Error : " + response.data.message,
                            type: 'error'
                        });
                    } else {
                        
                        // eslint-disable-next-line no-console
                        // console.log(response.data.data.teachers)
                        this.videos = response.data.data.videos;
                    }

                }).catch((error) => {
                    this.$toast.open({
                        message: "Error : " + error.response.data.message,
                        type: 'error'
                    });
                })
        },
        deleteItem(id) {
            if(confirm('Are you sure?') == true) {

                const config = {
                    headers: {
                        Authorization: "Bearer " + this.fastAdminToken,
                        'Content-Type': 'application/json'
                    }
                }

                axios.get(this.$apiURI + '/artvideo/' + id + '/delete', config)
                .then((response) => {
                    if (response.data.error) {
                        this.$toast.open({
                            message: "Error : " + response.data.message,
                            type: 'error'
                        });
                    } else {
                        
                        // eslint-disable-next-line no-console
                        // console.log(response.data.data.teachers)
                        this.initData();

                    }

                }).catch((error) => {
                    this.$toast.open({
                        message: "Error : " + error.response.data.message,
                        type: 'error'
                    });
                })
            }
        },
        clickedEditButton(video) {
            this.selectedVideo = video;
            this.showeditmodal = true;
        },
        editItem() {

            if(this.$refs.title.value == '') {
                this.$toast.open({
                        message: "Error : Please add title",
                        type: 'error'
                    })
                return;
            }

            if(this.$refs.description.value == '') {
                this.$toast.open({
                        message: "Error : Please add description",
                        type: 'error'
                    })
                return;
            }

            if(this.$refs.video.value == '') {
                this.$toast.open({
                        message: "Error : Please add video",
                        type: 'error'
                    })
                return;
            }



            let data = {
                title: this.$refs.title.value,
                description: this.$refs.description.value,
                video: this.$refs.video.value,
            }

            
            if(this.$refs.thumb.files.length != 0) {
                var reader1 = new FileReader()
                reader1.readAsDataURL(this.$refs.thumb.files[0])
                reader1.onload = () => {
                    data['thumb'] = reader1.result;
                    this.showeditmodal = false;

                const config = {
                    headers: {
                        Authorization: "Bearer " + this.fastAdminToken,
                        'Content-Type': 'application/json'
                    }
                }
                this.$toast.open({
                    message: "Processing : Adding Avatar Assets. Please Wait...",
                    type: 'info'
                })

                axios.post(this.$apiURI + `/artvideo/${this.selectedVideo._id}/update`, data, config)
                    .then((response) => {
                        this.loading = false;
                        if (response.data.error) {
                            this.$toast.open({
                                message: "Error : " + response.data.message,
                                type: 'error'
                            });
                        } else {
                            this.initData();
                            this.$toast.open({
                                message: "Avatar Assets Created Successfully",
                                type: 'success'
                            })
                        }

                    }).catch((error) => {
                        this.loading = false;
                        this.$toast.open({
                            message: "Error : " + error.response.data.message,
                            type: 'error'
                        });
                    })
                };

                return;

            }
            this.showeditmodal = false;

            const config = {
                        headers: {
                            Authorization: "Bearer " + this.fastAdminToken,
                            'Content-Type': 'application/json'
                        }
                    }
                    this.$toast.open({
                        message: "Processing : Adding Avatar Assets. Please Wait...",
                        type: 'info'
                    })

                    this.loading = true;
                    axios.post(this.$apiURI + `/artvideo/${this.selectedVideo._id}/update`, data, config)
                        .then((response) => {
                            this.loading = false;
                            if (response.data.error) {
                                this.$toast.open({
                                    message: "Error : " + response.data.message,
                                    type: 'error'
                                });
                            } else {
                                this.initData();
                                this.$toast.open({
                                    message: "Avatar Assets Created Successfully",
                                    type: 'success'
                                })
                            }

                        }).catch((error) => {
                            this.loading = false;
                            this.$toast.open({
                                message: "Error : " + error.response.data.message,
                                type: 'error'
                            });
                        })

        },
        updategender(gender) {
            this.gender = gender;
            this.initData();
        }
    }
}
</script>

